<template>
  <div>
    <transition name="fade">
      <div v-if="isOpen" class="chat-agent-overlay" :class="{ 'is-maximized': isMaximized }">
        <div class="chat-agent-container">
          <div class="chat-agent-header">
            <div class="flex items-center">
              <img
                src="@/assets/img/gemini-sparkle.svg"
                class="mr-3"
                width="24"
                height="24"
                alt="Gemini AI"
              />
              <h3 class="text-lg font-medium">Cualitywork AI Assistant</h3>
            </div>
            <div class="flex justify-end items-center">
              <v-btn icon dark title="Delete Chat History" @click="deleteHistory" class="mr-1">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
              <v-btn icon dark @click="toggleMaximize" class="mr-1">
                <v-icon>{{ isMaximized ? 'mdi-arrow-collapse' : 'mdi-arrow-expand' }}</v-icon>
              </v-btn>
              <v-btn icon dark @click="toggleChat">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
          </div>
          <div class="chat-agent-body">
            <iframe
              ref="chatIframe"
              :src="finalChatUrl"
              width="100%"
              height="100%"
              frameborder="0"
              title="Chat Agent"
            ></iframe>
          </div>
        </div>
      </div>
    </transition>

    <div class="chat-trigger-btn">
      <v-tooltip left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            fab
            dark
            color="#21427d"
            v-bind="attrs"
            v-on="on"
            @click="toggleChat"
            class="shadow-xl"
          >
            <img src="@/assets/img/gemini-sparkle.svg" width="28" height="28" alt="Gemini AI" />
          </v-btn>
        </template>
        <span>Chat with AI Assistant</span>
      </v-tooltip>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChatAgentWidget',
  data() {
    return {
      isOpen: false,
      isMaximized: false
    }
  },
  computed: {
    finalChatUrl() {
      return `https://bot-app-ai.myfinfi.com?embed=true`
      // // return `http://bot-app-ai.myfinfi.com.s3-website.ap-south-1.amazonaws.com?embed=true`
      // return `http://localhost:5173?embed=true`
    }
  },
  mounted() {
    this.onMessage = (e) => this.handleMessage(e, this)
    window.addEventListener('message', this.onMessage)
  },
  beforeDestroy() {
    window.removeEventListener('message', this.onMessage)
  },
  methods: {
    toggleChat() {
      this.isOpen = !this.isOpen
      if (!this.isOpen) this.isMaximized = false
      this.$emit('toggle', this.isOpen)
    },
    toggleMaximize() {
      this.isMaximized = !this.isMaximized
    },
    deleteHistory() {
      this.sendMessageToChatIframe({
        type: 'DELETE_HISTORY'
      })
    },
    handleMessage(event, _this) {
      const allowedOrigin = new URL(_this.finalChatUrl).origin
      if (event.origin !== allowedOrigin) {
        return
      }

      const { type } = event.data
      if (type === 'CHAT_READY') {
        _this.sendChatEnv()
      }
    },
    sendChatEnv() {
      const orgData = JSON.parse(localStorage.getItem('orgData') || '{}')
      const user = JSON.parse(localStorage.getItem('user') || '{}')
      const orgCode = localStorage.getItem('organization_code') || ''

      const payload = {
        orgId: '152' || '',
        orgCode: 'KWALTY' || '',
        userId: '66c62aad32bbac05d0a88866',
        firstName: 'Gaurav' || '',
        lastName: 'Shukla' || ''
      }
      console.log({ payload })

      this.sendMessageToChatIframe({
        type: 'CHAT_ENV',
        payload
      })
    },
    sendMessageToChatIframe(message) {
      const iframe = this.$refs.chatIframe
      if (!iframe) return
      const origin = new URL(this.finalChatUrl).origin
      iframe.contentWindow.postMessage(message, origin)
    }
  }
}
</script>

<style scoped>
.chat-agent-overlay {
  position: fixed;
  bottom: 90px;
  right: 25px;
  z-index: 2000;
}

.chat-agent-overlay.is-maximized {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: auto;
  height: auto;
  bottom: auto;
  right: auto;
}

.chat-agent-overlay.is-maximized .chat-agent-container {
  width: 800px;
  height: 80vh;
  max-width: 95vw;
  max-height: 95vh;
  border-radius: 16px;
}

.chat-agent-container {
  width: 450px;
  height: 650px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 12px 60px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid rgba(33, 66, 125, 0.2);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.chat-agent-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 20px;
  background: #21427d;
  color: white;
}

.chat-agent-body {
  flex-grow: 1;
  background: #fcfcfc;
}

.chat-trigger-btn {
  position: fixed;
  bottom: 25px;
  right: 25px;
  z-index: 2000;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateY(30px) scale(0.95);
  transform-origin: bottom right;
}

/* Ensure iframe fits perfectly */
iframe {
  border: none;
  display: block;
}

/* Dark mode adjustments if needed */
.dark .chat-agent-container {
  background: #1e1e1e;
  border-color: rgba(255, 255, 255, 0.1);
}
</style>
